import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import CustomTooltip from '../../../Tooltip';
import PreviewOriginal from '../../../PreviewOriginal';
import { cap } from '../../../../config';
import ClipboardCopy from "../../../../helpers/ClipboardCopy";
import CustomNotify from "../../../Notify";
import DataComponentPromo from "../../../DataComponent/DataComponentPromo";
import { I18nContext } from 'utils/I18n/context';

const columnTableData = {
    header: {
        0: {className: 'text-center', style: {width: 50}},
        1: {className: 'offer-item__table-banner', style: {width: 187}},
        2: {className: 'text-center'},
        3: {className: 'text-center'},
        4: {className: 'text-center'},
        5: {className: 'text-center'},
    },
    body: {
        0: {className: 'text-center'},
        1: {className: 'offer-item__table-banner'}
    }
};


const OfferPagePromoLinks = ({ 
    links, 
    totalPages, 
    headerNames, 
    loading, 
    getLinks: getLinksAction, 
    deletePromoCode,
    showConstructor,
    showConstructorPromoCode,
    showConstructorPromoCodeList
}) => {
    const { t } = useContext(I18nContext);
    const { id } = useParams();
    const [state, setState] = useState({
        offerId: id,
        links: links || []
    });

    const staticNames = t?.offersPage?.offer || { 
        promoCodes: 'Promo Codes', 
        defaultLink: 'Default Link' 
    };

    useEffect(() => {
        setState(prev => ({
            ...prev,
            offerId: id,
            links: links || []
        }));
    }, [id, links]);


    const onClickDeletePromoCode = useCallback((promoCodeId) => {
        let links = state.links;
        links.map((link) => {
            link.promo_codes.map((promoCode, j) => {
                if(promoCode.id === promoCodeId) {
                    delete link.promo_codes[j];
                }
            })
        });

        setState(prev => ({
            ...prev,
            links: links
        }));

        deletePromoCode(promoCodeId, t, () => {}, () => {});
    }, [state.links, deletePromoCode, t]);


    const handleShowConstructorPromoCodeList = useCallback((link) => {
        showConstructorPromoCodeList({'link': link});
    }, [showConstructorPromoCodeList]);

    const getLinks = useCallback(() => {
        let links = [];

        if (!state.links || !Array.isArray(state.links)) {
            return links;
        }

        state.links.map((link, i) => {
            let itemUrl = link.url.slice(0, 80);
            if (itemUrl.length < link.url.length) {
                itemUrl += ' ...';
            }

            let itemTitle = link.title.slice(0,60);
            if (itemTitle.length < link.title.length) {
                itemTitle += ' ...';
            }

            links.push({
                id: link.id,
                name: link.title,
                image: (
                    <div className="offer-item__table-img">
                        {link.thumbnail
                            ? (
                                <CustomTooltip id={`link-preview-${i}`} tooltip={<PreviewOriginal url={link.image} />} placement={'right'} theme={'preview'}>
                                    <a href={link.url} id={`link-preview-${i}`} target="_blank">
                                        <img src={link.thumbnail || cap} alt="" />
                                    </a>
                                </CustomTooltip>
                            )
                            : (
                                <a href={link.url} target="_blank">
                                    <img src={cap} alt="" />
                                </a>
                            )
                        }
                    </div>
                ),
                title: itemTitle,
                url:(<a href={link.url} target="_blank">{itemUrl}</a>),
                action: (
                    <div className="offer-item__promo-links-wrap">
                        <div className="offer-item__promo-links-toolbar">
                            <button
                                className={
                                    link.promo_codes && link.promo_codes.length > 0
                                        ? "btn btn-white generate-link"
                                        : "btn btn-white generate-link empty"
                                }
                                onClick={() => { handleShowConstructorPromoCodeList(link); }}
                                disabled={link.promo_codes && link.promo_codes.length <= 0}
                            >
                                {staticNames.promoCodes}
                            </button>
                        </div>
                    </div>
                ),
                selfLink: link.selfie_link ? 'Selfie' : staticNames.defaultLink,
                actions: null
            });
        });

        return links;
    }, [state.links, staticNames, handleShowConstructorPromoCodeList]);

    const onDataTableAction = useCallback((dataComponentState, actionType) => {
        getLinksAction({
            ...dataComponentState,
            offerId: state.offerId
        }, actionType);
    }, [getLinksAction, state.offerId]);

    return (
        <DataComponentPromo
            onAction={onDataTableAction}
            totalPages={totalPages}
            headerNames={headerNames}
            data={getLinks()}
            loading={loading}
            withoutDatepicker={true}
            textInput={true}
            alignPagination={true}
            columnData={columnTableData}
            hidden={false}
        />
    );
};

OfferPagePromoLinks.propTypes = {
    links: PropTypes.array,
    totalPages: PropTypes.number,
    headerNames: PropTypes.array,
    loading: PropTypes.bool,
    getLinks: PropTypes.func,
    deletePromoCode: PropTypes.func,
    showConstructor: PropTypes.func,
    showConstructorPromoCode: PropTypes.func,
    showConstructorPromoCodeList: PropTypes.func
};

OfferPagePromoLinks.defaultProps = {
    links: [],
    totalPages: 0,
    headerNames: [],
    loading: false,
    getLinks: () => {},
    deletePromoCode: () => {},
    showConstructor: () => {},
    showConstructorPromoCode: () => {},
    showConstructorPromoCodeList: () => {}
};

export { OfferPagePromoLinks };
